/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolSubItemController controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, SchoolSubsItem } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolSubItemControllerService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getItems(observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolSubsItem>>;
    getItems(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolSubsItem>>>;
    getItems(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolSubsItem>>>;
    getItems(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/items`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addItem(item: SchoolSubsItem, observe?: 'body', options?: RequestOptions<'text'>): Observable<string>;
    addItem(item: SchoolSubsItem, observe?: 'response', options?: RequestOptions<'text'>): Observable<HttpResponse<string>>;
    addItem(item: SchoolSubsItem, observe?: 'events', options?: RequestOptions<'text'>): Observable<HttpEvent<string>>;
    addItem(item: SchoolSubsItem, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/items`;

        let params = new HttpParams();
        if (item != null) {
            params = HttpParamsBuilder.addToHttpParams(params, item, 'item');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('post', url, {
            body: null,
            observe,
            headers,
            params,
            responseType: 'text',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
